import { IConfigsType } from '../../types'

const fwWingstopLossPreventionConfig: IConfigsType = {
  'fw_wingstop-store-base-r3d9tnva': {
    '/:brand/loss_prevention': {
      groupFilter: {
        api: 'locationFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'last_week',
          'this_week',
          'yesterday',
          'trailing_7_days',
          'custom',
        ],
      },
      title: {
        type: 'title',
        title: 'Loss Prevention',
      },
      expoAi: {
        type: 'ai-summary-box',
        api: 'locationLossPreventionAiSummary',
      },
      discountOutliers: {
        type: 'table-v2',
        title: 'Discount & Void Outliers',
        api: 'fwWingstopLossPreventionOutliers',
        emptyText: 'No Outlier Found',
        pagination: {
          pageSize: 10,
        },
        sorting: [
          {
            id: 'employeeName',
            desc: false,
          },
        ],
        columns: [
          {
            key: 'employeeName',
            title: 'Name',
            align: 'center',
            width: '100px',
            sortable: true,
          },
          {
            key: 'type',
            title: 'Type',
            align: 'center',
            width: '100px',
            sortable: true,
          },
          {
            key: 'date',
            title: 'Date',
            format: 'M/D/YYYY',
            align: 'center',
            width: '100px',
            sortable: true,
          },
          {
            key: 'time',
            title: 'Time',
            align: 'center',
            format: 'h:mma',
            width: '100px',
            sortable: true,
          },
          {
            key: 'value',
            title: 'Discount/Void Amount',
            decimal: 2,
            unit: 'dollar',
            align: 'center',
            width: '100px',
            sortable: true,
          },
          {
            key: 'checkNumber',
            title: 'Check #',
            align: 'center',
            width: '100px',
            sortable: true,
          },
        ],
      },
      discountBreakdownByEmployee: {
        type: 'table-v2',
        title: 'Discounts by Employee',
        api: 'fwWingstopListEmployeeDiscount',
        sorting: [
          {
            id: 'discountCompsPercentTotal',
            desc: true,
          },
        ],
        columns: [
          {
            key: 'discountTotalPercentRank',
            title: 'Rank',
            align: 'center',
            width: '100px',
            sortable: true,
          },
          {
            key: 'employeeName',
            title: 'Name',
            align: 'center',
            width: '250px',
            sortable: true,
          },
          {
            key: 'discountTypes',
            title: 'Discount Types',
            align: 'center',
            width: '200px',
            sortable: true,
          },
          {
            key: 'discountCheckCountTotal',
            title: 'Discount #',
            align: 'center',
            width: '125px',
            sortable: true,
          },
          {
            key: 'discountCompsTotal',
            title: 'Discount $',
            align: 'center',
            width: '125px',
            sortable: true,
          },
          {
            key: 'grossSales',
            title: 'Gross Sales',
            align: 'center',
            width: '125px',
            sortable: true,
          },
          {
            key: 'discountCompsPercentTotal',
            title: 'Discount %',
            align: 'center',
            width: '125px',
            sortable: true,
            background: {
              range: [0, 100],
              colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
              value: '<%- values.discountTotalPercentHeatmap %>',
            },
          },
        ],
      },
      cashHandlingByEmployee: {
        type: 'table-v2',
        title: 'Cash Handling by Employee',
        api: 'fwWingstopListEmployeeLossPrevention',
        sorting: [
          {
            id: 'lossPreventionVoidCheckCount',
            desc: true,
          },
        ],
        columns: [
          {
            key: 'employeeName',
            title: 'Name',
            align: 'center',
            width: '175px',
            sortable: true,
          },
          {
            key: 'checkCount',
            title: 'Checks Total #',
            align: 'center',
            width: '150px',
            sortable: true,
          },
          {
            key: 'void',
            title: 'Void',
            align: 'center',
            children: [
              {
                key: 'lossPreventionVoidCheckCount',
                title: '#',
                align: 'center',
                width: '100px',
                sortable: true,
              },
              {
                key: 'lossPreventionVoidAmount',
                title: '$',
                align: 'center',
                width: '100px',
                sortable: true,
              },
              {
                key: 'lossPreventionVoidCheckCountPercent',
                title: '%',
                align: 'center',
                width: '100px',
                sortable: true,
                background: {
                  range: [0, 100],
                  colors: ['hsl(120, 80%, 80%)', 'hsl(0, 80%, 80%)'],
                  value:
                    '<%- values.lossPreventionVoidCheckCountPercentHeatmap %>',
                },
              },
            ],
          },
        ],
      },
    },
  },
}

export default fwWingstopLossPreventionConfig
